import { forwardRef, ReactNode } from 'react'
import classNames from 'classnames'
import './iconButton.css'
import './textButton.css'

interface IconButtonProps {
  className?: string
  children: ReactNode
  onClick: (evt: React.MouseEvent<HTMLElement>) => void
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, className, onClick }, ref) => (
    <button
      ref={ref}
      className={classNames('text-button', 'icon-button', className)}
      onClick={onClick}
    >
      {children}
    </button>
  ),
)
